"use client";
import React from "react";
import { usePathname } from "@/i18n/navigation";
import InstagramPostGenerator from "../socialMedia/instagramPostGenerator/InstagramPostGenerator";
import FacebookPostGenerator from "../socialMedia/facebookPostGenerator/FacebookPostGenerator";
import TweetPostGenerator from "../socialMedia/tweetPostGenerator/TweetPostGenerator";
import YoutubePostGenerator from "../socialMedia/youtubePostGenerator/YoutubePostGenerator";
import TweetToImage from "../socialMedia/tweetToImage/TweetToImage";
import YouTubeYThumbnail from "../socialMedia/youTubeThumbnail/YouTubeYThumbnail";

function SocialMediaFormat() {
  const Name = usePathname();
  return (
    <>
      {Name === "/instagram-post-generator" && <InstagramPostGenerator />}
      {Name === "/facebook-post-generator" && <FacebookPostGenerator />}
      {Name === "/tweet-post-generator" && <TweetPostGenerator />}
      {Name === "/tweet-to-image" && <TweetToImage />}
      {Name === "/youtube-post-generator" && <YoutubePostGenerator />}
      {Name === "/youtube-thumbnail" && <YouTubeYThumbnail />}
    </>
  );
}

export default SocialMediaFormat;
